import Navbar from "../components/navbar";
import Footer from "../components/footer";

import React, { useEffect, useState } from "react";
import axios from 'axios';
import MapComponent from "../components/GoogleMap";
import PropertyCard from "../components/propertycard";
import PropertySearch from "../components/propertysearch";
import PageHeader from "../components/pageheader";

// const apiPath = 'https://localhost:7044/DimoraProperties';
//const apiPath = 'http://54.90.37.158/dimoraapi/dimoraproperties';
const apiPath = 'https://dimoraliving.com/dimoraproperties';

const mime = 'image/jpg';

function removeDuplicates(arr) 
{
    const uniqueObjects = [];
    const seenObjects = new Set();
    
    for(const obj of arr) 
    {
        const stringOfObj = JSON.stringify(obj);
        if(!seenObjects.has(stringOfObj)){
            uniqueObjects.push(obj);
            seenObjects.add(stringOfObj);
        }
    }
    return uniqueObjects;
}
export default function Furnished() {

    const [properties, setProperties] = useState([]);
    const [mapMarkers, setMapMarkers] = useState([]);
    
    useEffect(() =>{
        const fetchData = async () => {
            try {
                // grab data from api and place into state
                const response = await axios.get(apiPath);
                const data = response.data;
                setProperties(data);
                
                // derive array of map coordinates from original array
                let myMarkers = data.map(item => ({
                    address: item.address,
                    lat: item.lat,
                    lng: item.lng
                }))
                
                // remove duplicate coordinates
                myMarkers = removeDuplicates(myMarkers);
                console.log(myMarkers);
                setMapMarkers(myMarkers);
                
            } catch (error) {
                console.log(error);
            }
        }
        
        fetchData();
    }, [])
    
    const propertyImageDictionary ={
        "1487 5th Avenue, Troy, NY":"/apartmentimages/1487_5thAve",
        "172 River Street, Troy, NY":"/apartmentimages/172_RiverStTroy",
        "710 3rd Ave, Watervliet, NY":"/apartmentimages/710_3rdAve",
        "706 3rd Avenue, Watervliet, NY":"/apartmentimages/706_3rdAve"
    };
    
    return (
        <>
            <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-left"/>
            <PageHeader />
            <section className="section" style={{position: "relative", zIndex: 0, paddingTop: "calc(20vh + 300px)"}}>
                <div className="container-no-right-hand-padding">
                    <div className="row g-4">

                        {/*<div className="container mt-100 mt-60">*/}
                        
                        {/*</div>*/}
                        <div className="col-lg-8 col-md-7 col-12 mt-100">
                            <PropertySearch/>
                            {/* HOUSE CARDS  */}
                            <div className="row g-4 mt-0">
                                {properties.map((item,index) =>{
                                    return(
                                        <PropertyCard item={item} key={index} />
                                    )
                                })}
                            </div>
                            {/*<div className="container">*/}

                            {/*</div>*/}
                        </div>                        

                        {/* COLUMN GOES HERE*/}
                        <div className="col-lg-4 col-md-5 col-12">
                            <div className="card map border-0 sticky-bar-400">
                                <div className="card-body p-0">
                                    <MapComponent markers={mapMarkers}  />
                                </div>
                            </div>
                        </div>
                    </div>                    
                    
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <Footer/>
        </>)
}